
import { computed, defineComponent, nextTick, PropType, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  PortListDrawerService,
  QueryParams,
  RelieveParams,
  RuleItem
} from './block-rule-list-drawer.service'
import { TableDataRowState, TableState } from '@/services/table-memory-pagination'
import { TerminalItem } from '../../terminal-view.service'
import { ElMessage } from 'element-plus'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import { login_status } from '@/views/dashboard/response-manage/response-handle/types'
import { getRiskPortDisplayTextForPortRange } from '@/utils/port-risk-display'

enum SELECT_TYPE {
   APPOINT_RULE = 1,
   // eslint-disable-next-line no-magic-numbers
   ALL_RULE = 2
}

export default defineComponent({
  components: {
    ContentAdaptLayout,
    TerminalHead,
  },
  props: {
    device: {
      type: Object as PropType<TerminalItem>,
      default: {} as PropType<TerminalItem>
    },
  },
  setup (props, context) {
    const { t, te } = useI18n()
    const injector = useReflectiveInjector([PortListDrawerService])
    const service = injector.get(PortListDrawerService)
    const multipleTable = ref(null)
    const queryParams = reactive<QueryParams>({
      device_id: (props.device as TerminalItem).device_id,
      page: 1,
      limit: 10,
      asc: false,
      sort: '',
      useMemory: false
    })
    const data = reactive({
      tableData: [] as TableDataRowState<RuleItem>[],
      state: {} as TableState<TableDataRowState<RuleItem>>,
      total: 0,
    })
    service.onStateChange.subscribe(state => {
      data.state = state
      data.tableData = state.data.list
      data.total = state.data.total
      nextTick(() => {
        data.tableData.forEach(i => multipleTable.value?.toggleRowSelection(i, i.$selected))
      })
    })
    async function getData (isOperatePage:boolean = false) {
      !isOperatePage && (queryParams.page = 1)
      await service.refresh(queryParams)
    }

    function doRelieveBlockRule (params: RelieveParams) {
      service.doPortcontrolDeviceBlockedRulesCancel(params).then(async () => {
        ElMessage.success(t('portManage.relieveSuccess'))
        await getData()
        context.emit('refresh')
      }).catch(() => {
        ElMessage.error(t('portManage.relieveFailed'))
      })
    }

    getData()

    const headLoginStatus = computed(
      () => (props.device as TerminalItem).login_status ?? login_status.online
    )

    return {
      headLoginStatus,
      riskRuleRowDetail (row: RuleItem) {
        return getRiskPortDisplayTextForPortRange(t, te, row.port_start, row.port_end, row.system_type, row.risk_detail)
      },
      ...toRefs(data),
      multipleTable,
      queryParams,
      handleRelieveBlockRuleList () {
        const params: RelieveParams = {
          device_id: (props.device as TerminalItem).device_id,
          select_type: SELECT_TYPE.APPOINT_RULE,
          rule_id_list: []
        }

        if (data.state.selectAll) {
          params.select_type = SELECT_TYPE.ALL_RULE
        } else {
          params.rule_id_list = service.getSelectedData().map(item => item.rule_id)
        }

        doRelieveBlockRule(params)
      },
      handleRelieveBlockRule (ruleId: number) {
        const params: RelieveParams = {
          device_id: (props.device as TerminalItem).device_id,
          select_type: SELECT_TYPE.APPOINT_RULE,
          rule_id_list: [ruleId]
        }

        doRelieveBlockRule(params)
      },
      getListByMemory () {
        queryParams.useMemory = !queryParams.useMemory
        queryParams.page = 1
        queryParams.limit = 10
        getData()
      },
      togglePageSelect () {
        service.togglePageSelect()
      },
      selectAll () {
        queryParams.page = 1
        queryParams.useMemory = false
        service.selectAll()
        getData()
      },
      selectCancel () {
        queryParams.useMemory = false
        service.cancelSelectAll()
        getData()
      },
      calcActionBtnDisableStatus () {
        if (data.total && !data.state.selectAll) {
          return false
        }
        return true
      },
      handleSelectionChange (values: TableDataRowState<RuleItem>[], currentValue?: TableDataRowState<RuleItem>) {
        service.mergeSelectedData(values, currentValue)
      },
      handlerSizeChange (size: number) {
        queryParams.limit = size
        getData()
      },
      handlerCurrentChange (page: number) {
        queryParams.page = page
        getData(true)
      }
    }
  }
})
